<template>
   <v-app>
     <Navbar v-if="$route.meta.layout !== 'dark'" />
    <NavbarDark v-else />
    <v-main class="main-background" :style="containerStyle">
      <router-view />
    </v-main>
    <Footer v-if="$route.meta.layout !== 'dark'" />
   </v-app>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import Navbar from './components/Navbar.vue'
import NavbarDark from './components/NavbarDark.vue'
import Footer from './components/Footer.vue'

import { useTourStore } from '@/stores/tour'
import axios from 'axios'
import { useIntersectionObserver } from '@vueuse/core'
import fondolight from '@/assets/fondolight.jpg'

import { watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

// Función para crear un link desde cero
const createLink = (rel, href, hreflang = null) => {
  const link = document.createElement('link')
  link.setAttribute('rel', rel)
  link.setAttribute('href', href)
  if (hreflang) link.setAttribute('hreflang', hreflang)
  document.head.appendChild(link)
}

watch(
  () => route.path,
  () => {
    const baseUrl = 'https://burutik.eus'
    const currentPath = route.path
    
    // 1. LIMPIEZA TOTAL: Borramos el canonical y todos los alternates viejos
    document.querySelectorAll("link[rel='canonical'], link[rel='alternate']").forEach(el => el.remove())

    // 2. CREAR CANONICAL (La URL actual)
    // Evitamos la doble barra si es la raíz
    const cleanCurrentPath = currentPath === '/' ? '' : currentPath
    
    // 3. CREAR ALTERNATES (La versión espejo)
    if (currentPath.startsWith('/cas')) {
      // Estamos en Castellano -> La alternativa es Euskera
      createLink('canonical', baseUrl + cleanCurrentPath, 'es')
      // Quitamos /cas del principio. Si queda vacío, ponemos /
      const euPath = currentPath.replace('/cas', '') || '/'
      createLink('alternate', baseUrl + euPath, 'eu')
    } else {
      // Estamos en Euskera -> La alternativa es Castellano
      createLink('canonical', baseUrl + cleanCurrentPath, 'eu')
      const esPath = '/cas' + (currentPath === '/' ? '' : currentPath)
      createLink('alternate', baseUrl + esPath, 'es')
    }

    // 4. CREAR X-DEFAULT (Siempre a la Home en euskera)
    createLink('alternate', baseUrl + '/', 'x-default')
  },
  { immediate: true }
)


const concertStore = useTourStore()

onMounted(async () => {
  try {
    const res = await axios.get('/api/tour')
    if (res.data.ok) {
      concertStore.setTourDatak(res.data.dates)
      console.log('Fechas cargadas correctamente:', res.data.dates)
    } else {
      console.error('Error al cargar las fechas:', res.data)
    }
  } catch (error) {
    console.error('Error al obtener las fechas:', error)
  }
})
const el = ref(null)
const isVisible = ref(false)
const isLoaded = ref(false)

useIntersectionObserver(el, ([entry]) => {
  if (entry.isIntersecting) {
    isVisible.value = true
    // Pre-carga la imagen antes de mostrarla
    const img = new Image()
    img.src = fondolight
    img.onload = () => {
      isLoaded.value = true
    }
  }
})
const containerStyle = computed(() => ({
  backgroundColor: '#e2d7c0',
  backgroundImage: isLoaded.value ? `url(${fondolight})` : 'none',
}))
</script>

<style>
.main-background {
  background-size: cover;
  background-position: center;
  background-attachment: fixed; /* para efecto tipo “parallax” */
  min-height: 100vh;
}
body {
  font-family: 'Inter Tight', sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-height: 100vh;
  max-width: 100%;
  /* overflow-x: hidden;  */
}

router-view {
  flex: 1;
}
</style>
